/**
 * Group requirement strings encode checkbox/radio group validation rules.
 *
 * Format: require_<min>[-<max|ormore>]
 * Examples: "require_1", "require_1-3", "require_2-ormore"
 *
 * Two regex variants exist for different trust levels:
 *
 * - STRICT (anchored ^…$): rejects partial matches like "require_1-2junk"
 *   or corrupted strings like "require_uire_9". Used by the signer, which
 *   receives data through the API and must treat it as untrusted.
 *
 * - PARSE (unanchored): extracts min/max from known-valid strings.
 *   Used by the editor, which reads back its own buildRequirement() output.
 *
 * Related: buildRequirement() in checkbox-options.tsx / radiobutton-options.tsx
 * produces these strings on the editor side.
 *
 * @see SIGN-14073 for the invariant error root cause and editor regex bug.
 */

/** Anchored regex that captures min and optional max from a requirement string. */
export const GROUP_REQUIREMENT_PATTERN_STRICT =
  /^require_(\d+)(?:-(\d+|ormore))?$/;

/** Unanchored regex that captures min and optional max from a requirement string. */
export const GROUP_REQUIREMENT_PATTERN = /require_(\d+)(?:-(\d+|ormore))?/;

/** Anchored validation-only pattern (tests format without capturing min). */
export const GROUP_REQUIREMENT_VALID = /^require_\d+(?:-(\d+|ormore))?$/;
